import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Image from './../Image'
import bemClass from './../../utils/bemClass'
import prettyText from './../../utils/prettyText'

import './Slider.css'

const cn = bemClass('Slider')

class Item extends PureComponent {
    render() {
        const { title, subtitle, image } = this.props

        return (
            <div className={cn('item')}>
                <Image
                    src={image}
                    className={cn('image')}
                    containerClassName={cn('image-container')}
                    placeholderClassName={cn('image-placeholder')}
                    alt={title}
                />
                <div className={cn('description')}>
                    <div
                        className={cn('title')}
                        dangerouslySetInnerHTML={prettyText(title)}
                    />
                    <div
                        className={cn('subtitle')}
                        dangerouslySetInnerHTML={prettyText(subtitle)}
                    />
                </div>
            </div>
        )
    }
}

Item.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.string,
}

export default Item



// WEBPACK FOOTER //
// ./src/components/Slider/Item.jsx